<template lang="pug">
  .company-details(v-if="companyDetails")
    .company-details__border.company-details__border--top
    .company-details__border.company-details__border--right
    .company-details__border.company-details__border--bottom
    .company-details__border.company-details__border--left
    .company-details__corner.company-details__corner--tl
    .company-details__corner.company-details__corner--tr
    .company-details__corner.company-details__corner--bl
    .company-details__corner.company-details__corner--br
    .company-details__decor-top
    .company-details__decor-bottom
    .company-details__title(v-if="h1") {{h1}}
    .company-details__content
      h3.company-details__subtitle(v-if='companyDetails.subtitle') {{ companyDetails.subtitle }}
      .company-details__address(v-if='companyDetails.address')
        .company-details__address-item(v-for="(item, index) in companyDetails.address" :key="index")
          .company-details__address-item-title(v-if='item.title') {{ item.title }}
          .company-details__address-item-text(v-if='item.text') {{ item.text }}
      .company-details__details
        .company-details__details-item(v-for="(item, index) in companyDetails.details" :key="index")
          span.company-details__details-item-title(v-if='item.title') {{ item.title }}
          p.company-details__details-item-text(v-if='item.text') {{ item.text }}
        .company-details__details-item-block
          p.company-details__details-item-text(v-if='companyDetails.bank') {{ companyDetails.bank }}
          p.company-details__details-item-text(v-if='companyDetails.direction') {{ companyDetails.director }}

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/companyDetails/companyDetails.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

export default {
  name: 'CompanyDetails',

  mixins: [AjaxHelpersVue],

  data() {
    return {
      companyDetails: null,
      ps: null
    }
  },

  components: {},

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadCompanyDetailsPage', params => {
      this.request(params.url);
    });
  },

  methods: {
    request(url) {
      this.req('CompanyDetailsPage:getCompanyDetailsPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.companyDetails = res.content;

          this.$nextTick(() => {
            this.initScroll();
          });
        }
      }, 'company-details');
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.company-details__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      }
      else {
        this.ps.update();
      }
    },
  }
}
</script>
